import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlMatchResult, UrlSegment, UrlTree } from '@angular/router';

/** First URL segment of the retired admin prefix. */
const LEGACY_SEGMENT = 'orchestration';

/**
 * Matches `/admin/orchestration` and every child segment.
 * The redirect keeps that tail under `/admin/process-management`.
 */
export function orchestrationLegacyUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments[0]?.path !== LEGACY_SEGMENT) {
    return null;
  }
  return { consumed: segments };
}

/** Opens the same screen on the current prefix, including query and fragment. */
export function orchestrationLegacyRedirect(
  snapshot: Pick<ActivatedRouteSnapshot, 'url' | 'queryParams' | 'fragment'>,
): UrlTree {
  const tail = snapshot.url.slice(1).map(segment => segment.path);
  return inject(Router).createUrlTree(['/admin', 'process-management', ...tail], {
    queryParams: snapshot.queryParams,
    fragment: snapshot.fragment || undefined,
  });
}
